// @flow

import * as React from 'react';

import {
  selectCartUUID,
  type ProductId,
  type ProductPayload,
} from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { ListRow } from '../../../../ListRow';

export type Props = {
  productId: ProductId,
  owner: $NonMaybeType<ProductPayload['owner']>,
  canChangeOwner: $NonMaybeType<ProductPayload['change_owner']>,
};

export default function OwnerRow({
  productId,
  owner,
  canChangeOwner,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const cartId = useAppSelector(selectCartUUID);

  const ownerName = `${owner.given} ${owner.family}`;
  const ownerDisplayName = owner.orgname
    ? `${owner.orgname} – ${ownerName}`
    : ownerName;

  return (
    <ListRow
      intent="muted"
      title={`${__('Owner')} ${ownerDisplayName}`}
      options={
        !canChangeOwner
          ? [
              __(
                'The owner of the transferred domains cannot be modified as per registry policy. The owner will remain the same after the transfer.',
              ),
            ]
          : undefined
      }
      optionsArrow={false}
      {...(canChangeOwner && {
        cta: (
          <Button
            kind="link"
            to={`/cart/${cartId}/configure/${productId}/contacts/owner`}
          >
            {__('Change')}
          </Button>
        ),
      })}
    />
  );
}
